<template>
  <button
    class="wc-atc-button-modern__action"
    :disabled="disabled"
    @click="openModal"
    ref="addToListModalBtnRef"
    type="button"
  >
    <!-- Migrated: non-MTO add-to-list flow UI -->
    <font-awesome-icon icon="list-check" class="ml-2" />
    <span v-if="showText">{{ t('addToList') }}</span>
  </button>
</template>

<script setup>
import { computed, ref, defineProps, defineEmits } from 'vue';
import { useI18n } from 'vue-i18n';

import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import ModalService from '@/modules/modals/services/modal.service';
import { BTN_VARIANT } from '@/constants/AppConstants';
import WCAddToListModal from '@/modules/lists/components/WCAddToListModal/WCAddToListModal.vue';

const props = defineProps({
  item: {},
  btnVariant: {
    type: String,
    validator: value => BTN_VARIANT[value],
    default: BTN_VARIANT.LINK,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  instructions: {
    type: String,
  },
});

const emit = defineEmits(['close']);
const { t } = useI18n();
const store = useStore();
const router = useRouter();
const addToListModalBtnRef = ref(null);

const isGuest = computed(() => store.getters['user/isGuest']);
const getItemVariation = computed(() => store.getters['items/getItemVariation']);
const showText = computed(() => props.btnVariant !== BTN_VARIANT.MOBILE_CARD);

const createVariation = itemId => store.dispatch('items/createVariation', itemId);

async function open() {
  emit('close');

  try {
    if (props.item && (props.item.hasModifiers || props.item.hasLinkedItems)) {
      await createVariation(props.item.id);
    }

    await ModalService.open(WCAddToListModal, {
      item: props.item,
      variation: getItemVariation.value || null,
    });
  } catch (error) {
    console.error(error);
  } finally {
    if (addToListModalBtnRef.value) addToListModalBtnRef.value.focus();
  }
}

async function openModal() {
  if (!isGuest.value) {
    await open();
  } else {
    await router.push('/login');
  }
}
</script>

<style lang="scss" scoped>
.add-to-list--btn-mobile {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: auto;
}

.wc-atc-button-modern__action {
  width: 100%;
  height: 2.25rem;
  gap: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--primary);
  font-size: 0.875rem;
  font-weight: 700;
  background: var(--white);
  border: none;
  border-top: 0.5px solid var(--dark-lighter-5);

  &:focus {
    outline: none;
  }
}
</style>
